function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0V0Z",
  fill: "#000200"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.61372 7.52289L3.25031 8.51975C3.24787 8.48652 3.24662 8.45293 3.24662 8.41906C3.24662 7.67171 3.85245 7.06588 4.5998 7.06588C5.00344 7.06588 5.3658 7.2426 5.61372 7.52289V7.52289ZM3.56282 9.28847L5.94486 8.26997L6.83489 7.8894C6.59608 6.88512 5.69318 6.13818 4.61583 6.13818C3.35613 6.13818 2.33496 7.15936 2.33496 8.41906C2.33496 8.87557 2.46908 9.30076 2.70004 9.65738L3.56282 9.28847Z",
  fill: "url(#paint0_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.59961 9.77273C4.33642 9.77273 4.09077 9.6976 3.88296 9.5676L3.38721 10.3417C3.74179 10.5688 4.16334 10.7004 4.61564 10.7004C5.22197 10.7004 5.77304 10.4639 6.18157 10.078L5.53694 9.39551C5.29377 9.62913 4.96346 9.77273 4.59961 9.77273Z",
  fill: "url(#paint1_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.61276 10.644C8.63872 10.5968 8.65171 10.5732 8.65171 10.5732L8.99109 9.71067L8.18507 9.38543V4.91699H7.26592V9.24402C7.24596 9.7981 7.46041 10.167 7.90926 10.3505C8.37826 10.5462 8.61276 10.644 8.61276 10.644V10.644Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.7306 7.90327C13.5115 6.8462 12.575 6.05176 11.4529 6.05176C11.1871 6.05176 10.9318 6.09633 10.6938 6.17842L11.0015 7.06985C11.143 7.02103 11.2948 6.99451 11.4529 6.99451C12.12 6.99451 12.6768 7.46669 12.8074 8.09508L13.7306 7.90327Z",
  fill: "#FFEC00"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.7367 8.82455L12.8035 8.68066C12.6654 9.29906 12.1134 9.76127 11.4534 9.76127C11.2923 9.76127 11.1376 9.73374 10.9938 9.68311L10.6807 10.5726C10.9224 10.6577 11.1825 10.704 11.4534 10.704C12.5853 10.704 13.5284 9.89554 13.7367 8.82455V8.82455Z",
  fill: "#E30016"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.5559 9.43069C10.2584 9.17696 10.0697 8.79937 10.0697 8.37773C10.0697 7.95327 10.2609 7.57345 10.5618 7.31969L9.93045 6.61914C9.43828 7.04566 9.12695 7.67534 9.12695 8.37773C9.12695 9.08644 9.44391 9.72114 9.9438 10.1478L10.5559 9.43069Z",
  fill: "#009EE0"
});

var _ref9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: -4.05107,
  y1: -10.0052,
  x2: -1.60644,
  y2: -12.5367,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D4D1CF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: -5.60113,
  y1: -13.09,
  x2: -4.94866,
  y2: -14.2201,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D4D1CF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white"
})));

var SvgElo = function SvgElo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgElo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/elo.f4b37a41.svg";
export { ForwardRef as ReactComponent };